import React from 'react';
import Popover from 'material-ui/Popover';

const popoverStyles = {
    container: {
        padding: '12px 16px',
        maxWidth: '320px',
        fontSize: '12px',
        lineHeight: '1.5',
    },
    title: {
        fontWeight: 'bold',
        marginBottom: '8px',
        fontSize: '13px',
    },
    row: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '4px',
    },
    icon: {
        width: '16px',
        marginRight: '8px',
        /** @type {'center'} */
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: '13px',
    },
    label: {
        flex: 1,
    },
    divider: {
        borderTop: '1px solid #eee',
        margin: '8px 0',
    },
    summary: {
        fontSize: '11px',
        color: '#666',
        fontStyle: 'italic',
    },
};

const DataFillRatioPopover = ({ open, anchorEl, onClose, details, counter, total }) => (
    <Popover
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        targetOrigin={{ horizontal: 'left', vertical: 'top' }}
        onRequestClose={onClose}
        useLayerForClickAway={false}
        style={{ pointerEvents: 'none' }}
    >
        <div style={popoverStyles.container}>
            <div style={popoverStyles.title}>Data Fill Ratio ({counter}/{total})</div>

            {details.map((d) => (
                <div key={d.label} style={popoverStyles.row}>
                    <span
                        style={{
                            ...popoverStyles.icon,
                            color: d.ok ? '#4CAF50' : '#F44336',
                        }}
                    >
                        {d.ok ? '✓' : '✗'}
                    </span>
                    <span style={{
                        ...popoverStyles.label,
                        color: d.ok ? 'inherit' : '#999',
                    }}>
                        {d.label}
                    </span>
                </div>
            ))}

            <div style={popoverStyles.divider} />
            <div style={popoverStyles.summary}>
                {counter === total
                    ? 'All data fields are set.'
                    : `${total - counter} field(s) missing.`}
            </div>
        </div>
    </Popover>
);

export default DataFillRatioPopover;



// WEBPACK FOOTER //
// ./app/components/Vessels/List/DataFillRatioPopover.jsx